import LocaleUk from '@/i18n/uk.js'
import LocaleRu from '@/i18n/ru.js'

const LS_KEY = 'locale';

const LOCALE_CODES = ['uk', 'ru'];

function getMessagesObject() {
    return {
        uk: LocaleUk,
        ru: LocaleRu
    }
}

function detect() {
    const navLang = navigator.language || navigator.userLanguage;

    let retVal = 'uk'; //default locale

    LOCALE_CODES.forEach(l => {
        if (navLang.includes(l)) {
            retVal = l;
        }
    })
    
    return retVal;
}

function isLocaleSaved() {
    return window.localStorage.getItem(LS_KEY) !== null;
}

function getSavedLocale() {
    return window.localStorage.getItem(LS_KEY);
}

function updateLocale(locale) {
    window.localStorage.setItem(LS_KEY, locale);
}

export default {
    detect,
    getMessagesObject,
    getSavedLocale,
    isLocaleSaved,
    updateLocale
}